import React from 'react';
import L from 'leaflet';
import Typography from '@material-ui/core/Typography';
import _ from 'lodash';

const style = {
    width: '100%',
    height: '200px',
};

class LocationMap extends React.Component {
    componentDidMount() {
        let lat = _.get(this.props.location, 'geo.latitude');
        let long = _.get(this.props.location, 'geo.longitude');

        if (!lat || !long) {
            return;
        }

        // create map
        this.map = L.map('map', {
            center: [lat, long],
            zoom: 12,
            layers: [L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {})],
        });

        // add layer
        this.layer = L.layerGroup().addTo(this.map);

        L.marker({ lat, lng: long }, { title: '' }).addTo(this.layer);
    }

    render() {
        let lat = _.get(this.props.location, 'geo.latitude');
        let long = _.get(this.props.location, 'geo.longitude');
        if (!lat || !long) {
            return <Typography variant="body1">Location Not Available</Typography>;
        }
        let city = _.get(this.props.location, 'city', '');
        let region = _.get(this.props.location, 'region', '');
        let country = _.get(this.props.location, 'country', '');
        return (
            <div>
                <Typography variant="body1">
                    {city}, {region}, {country}
                </Typography>
                <div id="map" style={style} />
            </div>
        );
    }
}

export default LocationMap;
